import {
  WEB_PUSH_INSTALL_INTENT_EVENT,
  WEB_PUSH_INSTALL_INTENT_STORAGE_KEY,
  webPushInstallIntentSchema,
} from "@/lib/webPushInstallIntent";

export function recordWebPushInstallIntent() {
  if (typeof window === "undefined") return;

  const intent = webPushInstallIntentSchema.parse({ requestedAt: Date.now() });
  try {
    window.localStorage.setItem(WEB_PUSH_INSTALL_INTENT_STORAGE_KEY, JSON.stringify(intent));
  } catch {
    // Storage may be unavailable; the current tab should not auto-open install instructions.
  }
  window.dispatchEvent(new Event(WEB_PUSH_INSTALL_INTENT_EVENT));
}
